import { render } from "./Sectors.vue?vue&type=template&id=295febef&scoped=true"
import script from "./Sectors.vue?vue&type=script&lang=js"
export * from "./Sectors.vue?vue&type=script&lang=js"

import "./Sectors.vue?vue&type=style&index=0&id=295febef&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\oscar\\Documents\\GitHub\\ReSeT\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295febef"]])

export default __exports__